(function () {
  var SELECTOR = '[data-kevilagu-product]';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getSectionHeaderText(node) {
    if (!node || node.tagName !== 'UL' || node.children.length !== 1) return null;
    var li = node.children[0];
    if (li.children.length !== 1 || li.children[0].tagName !== 'STRONG') return null;
    if (li.textContent.trim() !== li.children[0].textContent.trim()) return null;
    return li.children[0].textContent.trim();
  }

  function splitDescriptionAccordion(root) {
    var wrapper = root.querySelector('[data-kl-split-description]');
    if (!wrapper || wrapper.dataset.klSplitDone === 'true') return;

    var contentEl = wrapper.querySelector('.accordion__content');
    var caretEl = wrapper.querySelector('.icon-caret');
    if (!contentEl || !caretEl) return;

    var children = Array.prototype.slice.call(contentEl.children);
    var sections = [];
    var current = null;

    children.forEach(function (node) {
      var heading = getSectionHeaderText(node);
      if (heading) {
        current = { heading: heading, nodes: [] };
        sections.push(current);
      } else {
        if (!current) {
          current = { heading: 'Overview', nodes: [] };
          sections.push(current);
        }
        current.nodes.push(node);
      }
    });

    sections = sections.filter(function (section) {
      return section.nodes.length > 0;
    });

    // Content didn't match the expected header pattern - leave the single block as-is.
    if (sections.length < 2) return;

    wrapper.dataset.klSplitDone = 'true';

    var sectionId = wrapper.dataset.sectionId;
    var caretHTML = caretEl.innerHTML;
    var fragment = document.createDocumentFragment();

    sections.forEach(function (section, index) {
      var block = document.createElement('div');
      block.className = 'product__accordion accordion quick-add-hidden';

      var details = document.createElement('details');
      details.id = 'Details-description-' + index + '-' + sectionId;

      var summary = document.createElement('summary');
      summary.id = 'Summary-description-' + index + '-' + sectionId;
      summary.innerHTML =
        '<div class="summary__title"><h2 class="h4"></h2></div>' +
        '<span class="svg-wrapper icon-caret">' + caretHTML + '</span>';
      summary.querySelector('h2').textContent = section.heading;

      var contentWrap = document.createElement('div');
      contentWrap.className = 'accordion__content rte';
      contentWrap.id = 'ProductAccordion-description-' + index + '-' + sectionId;
      section.nodes.forEach(function (node) {
        contentWrap.appendChild(node);
      });

      details.appendChild(summary);
      details.appendChild(contentWrap);
      block.appendChild(details);
      fragment.appendChild(block);
    });

    wrapper.replaceWith(fragment);
  }

  function initDescriptionSplit() {
    document.querySelectorAll(SELECTOR).forEach(splitDescriptionAccordion);
  }

  function init(root) {
    if (!root || root.dataset.klProductReady === 'true' || typeof window.gsap === 'undefined') return;
    root.dataset.klProductReady = 'true';

    if (reducedMotion()) return;

    var gsap = window.gsap;
    var media = root.querySelector('.product__media-wrapper');
    var info = root.querySelector('.product__info-container');

    if (media) {
      gsap.fromTo(media, { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: 0.8, ease: 'power3.out' });
    }

    if (info) {
      gsap.fromTo(
        info.children,
        { autoAlpha: 0, y: 18 },
        { autoAlpha: 1, y: 0, duration: 0.7, stagger: 0.08, ease: 'power3.out', delay: 0.15 }
      );
    }
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  function loadScript(src, marker) {
    return new Promise(function (resolve) {
      var existing = document.querySelector('script[data-' + marker + ']');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
        } else {
          existing.addEventListener('load', resolve, { once: true });
        }
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.dataset[marker] = 'true';
      script.addEventListener('load', function () {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      document.head.appendChild(script);
    });
  }

  function boot() {
    initDescriptionSplit();

    if (window.gsap) {
      initAll();
      return;
    }
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', 'kevilaguGsap').then(initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector(SELECTOR) : null;
    if (root) {
      splitDescriptionAccordion(root);
      if (window.gsap) {
        init(root);
      } else {
        loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', 'kevilaguGsap').then(function () { init(root); });
      }
    }
  });
})();
